// extracted by mini-css-extract-plugin
export default {"container":"MacroPicker-module__container--tNu5B"};